// extracted by mini-css-extract-plugin
export default {"code":"default_code__mYfit","code__label":"default_code__label__4fCgl","code__input":"default_code__input__layYU"};